import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Rest from "../../services/Rest";
const initialState = {
    correo: "",
    error: false,
    message: "",
    success: false
}

class Recovery extends Component {

    state = { ...initialState }

    constructor(props) {
        super(props);
        this.Rest = new Rest();
    }

    handleSubmit = (e) => {

        e.preventDefault();


        const { correo } = this.state

        if (correo === "") {
            this.setState({
                success: false,
                error: true,
                message: "El campo correo es obligatorio"
            })
            return;
        }

        this.refs.btn.setAttribute("disabled", "disabled");
        this.refs.btn.innerHTML = "Enviando...";

        this.Rest.get("usuarios/recuperar/" + this.state.correo)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        error: false,
                        success: true,
                        message: response.message
                    })
                    this.refs.btn.innerHTML = "Enviado";
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            success: false,
                            error: true,
                            message: response.message
                        })
                        this.refs.btn.removeAttribute("disabled", "disabled");
                        this.refs.btn.innerHTML = "Recuperar mi contraseña";
                    }
                }
            })
            .catch(err => {
                this.setState({
                    success: false,
                    error: true,
                    message: "Error de red"
                })
            })


        this.setState({
            ...initialState
        })

    }

    handleChange = e => {
        this.setState({
            correo: e.target.value
        })
    }


    render() {
        const { error, message, success } = this.state;
        return (
            <Fragment>
                <div className="form-login-container">
                    {error ? <div className="alert alert-danger">{message}</div> : null}
                    {success ? <div className="alert alert-success">{message} <a className="btn btn-success btn-block" href={window.location.origin}>Iniciar sesión</a></div> : null}
                    <form onSubmit={this.handleSubmit} autoComplete="off">
                        <div className="form-group">
                            <label>Ingresa su correo electrónico para recuperar su contraseña</label>
                            <input type="email" name="correo" id="correo" className="form-control"
                                onChange={this.handleChange} />
                        </div>
                        <button className="btn btn-primary" type="submit" ref="btn">Recuperar mi contraseña</button>
                        <Link to="/" className="btn ml-2">Cancelar</Link>
                    </form>
                </div>
            </Fragment >
        );
    }
}

export default Recovery;


// WEBPACK FOOTER //
// ./src/components/main/Recovery.js